<template>
  <v-dialog
    :value="isOpen"
    width="500"
    @input="val => $emit('dialogToggle', val)">
    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title>
        {{ dialogHeader }}
      </v-card-title>

      <v-card-text>
        {{ dialogBody }}
        <slot/>
      </v-card-text>

      <v-divider/>

      <v-card-actions>
        <v-spacer/>

        <v-btn
          flat
          @click="$emit('dialogToggle', false)"
        >
          {{ cancelButtonText ? cancelButtonText : $t('cancel') }}
        </v-btn>

        <disabled-user-button>
          <v-btn
            slot-scope="{isDisabledForUser}"
            :loading="isLoading"
            :disabled="isDisabledForUser || isLoading || isButtonDisabled || isDisabled"
            :color="isDelete ? `error` : `primary`"
            @click="$emit('confirm')"
          >
            {{ confirmButtonText }}
          </v-btn>
        </disabled-user-button>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DisabledUserButton from '@/components/global-components/disabledUserButton/disabledUserButton'
export default {
  name: 'ConfirmDialog',
  components: { DisabledUserButton },
  props: [
    'isOpen',
    'dialogHeader',
    'dialogBody',
    'isLoading',
    'isDisabled',
    'isDelete',
    'isButtonDisabled',
    'confirmButtonText',
    'cancelButtonText'
  ],
  i18n: {
    messages: {
      de: {
        cancel: 'Abbrechen'
      },
      en: {
        cancel: 'Cancel'
      },
      tr: {
        cancel: 'İptal'
      },
      ru: {
        cancel: 'Отмена'
      }
    }
  }
}
</script>

<style scoped>

</style>
